import { devToolsEnabled } from "@/lib/build-channel";
import {
    captureSentryException,
    captureSentryMessage,
    triggerSentryNativeCrash
} from "@/lib/sentry-init";

export type SentryTestKind = "message" | "error" | "native";

/**
 * Sends a test event (or a deliberate native crash) to Sentry. Developer tool:
 * a no-op in the production app (see lib/build-channel.ts), whoever calls it.
 */
export function triggerSentryTest(kind: SentryTestKind) {
    if (!devToolsEnabled()) {
        return;
    }
    switch (kind) {
        case "message":
            captureSentryMessage("[sentry-test] message", "info");
            return;
        case "error":
            captureSentryException(new Error("[sentry-test] manual error trigger"));
            return;
        case "native":
            triggerSentryNativeCrash();
            return;
    }
}
